import PerfilValidations from "./validations/PerfilValidations"
import UserValidations from "./validations/UserValidations"
import ImportarBeneficiarios from "./validations/ImportarBeneficiarios"

export default {
    /* COMMONS MESSAGES */
    invalid: "inválido",
    required: "obrigatório",
    access_denied: "Acesso negado!",
    unexpected_error: "Erro inesperado!",
    error_server_connection: "Houve um problema de comunicação com o servidor!",
    internal_connection_error: "Erro de comunicação interna!",
    user_whithout_email: "Atenção, entre em contato para cardastrar um email ao seu CPF.",
    invalid_token_mfa_for_user: "Token inválido!",
    fieldScope: {
        email: {
            invalid: "Inválido. Por favor, digite o e-mail correto.",
            already_exist: "E-mail já está sendo utilizado por outro usuário no sistema"
        },
        cpf: {
            invalid: "Inválido. Por favor, digite o número de cpf correto.",
            already_exist: "CPF já está sendo utilizado por outro usuário no sistema"
        },

        login: {
            invalid_grant: "Não foi possível consultar o cliente. Verifique os dados e tente novamente.",
            invalid_token_mfa_for_user: "Token inválido!"
        }
    },

    


    /* CONTEXT - IS PRIORITY*/
    context: {
        ...PerfilValidations,
        ...UserValidations,
        ...ImportarBeneficiarios,
        login: {
            authentication_error: "Erro na autenticação.",
            invalid_grant: "Não foi possível consultar o cliente. Verifique os dados e tente novamente.",
            invalid_token_mfa: "Token inválido."
        },
    }
}